/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import { FormControlLabel, Checkbox, Typography, Grid } from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useDispatch } = Redux;
import { useIntl } from 'react-intl';
const { saveGoGreen } = Slices.appSlice;
import ClassNames from 'classnames';
import actgreen from '../images/actgreen.svg';
import { capitalizeFirstLetter } from 'spwa-ui-library/esm/utils/helper';
import { TiTick } from '@react-icons/all-files/ti/TiTick';

import css from './index.module.scss';
import { useLocation } from '@reach/router';

// TODO: Verify what is the mechanism to show the defaultchecked status of options
// TODO: Verify what decides when to show this component
// TODO: Send this data in cart and order
export default function GoGreen({ config, className }) {
  const {
    GO_GREEN_DESCRIPTION: description,
    GO_GREEN_HEADING: heading,
    GO_GREEN_OPTIONS: options,
  } = config;
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const initialPayload = {};
  // eslint-disable-next-line no-unused-expressions
  options?.forEach((option) => {
    initialPayload[option?.type] = 1;
  });
  const [checkedOptions, setCheckedOptions] = useState(initialPayload);

  useEffect(() => {
    if (!location.pathname.includes('checkout')) {
      let deliveryInstructions = Object.keys(initialPayload || {});
      let deliveryInstructionString = deliveryInstructions
        .map((instr) => options.find((op) => op.type == instr)?.[`name_${intl.locale}`])
        .join(', ');
      dispatch(
        saveGoGreen({
          GoGreenVal: deliveryInstructionString,
        })
      );
    }
  }, []);

  const handleGoGreen = (type) => (e) => {
    e.preventDefault();
    e.persist();

    const payload = JSON.parse(JSON.stringify(checkedOptions));
    if (payload[type]) {
      delete payload[type];
    } else {
      payload[type] = 1;
    }

    setCheckedOptions((prev) => payload);

    let deliveryInstructions = Object.keys(payload || {});
    let deliveryInstructionString = deliveryInstructions
      .map((instr) => options.find((op) => op.type == instr)?.[`name_${intl.locale}`])
      .join(', ');
    dispatch(
      saveGoGreen({
        GoGreenVal: deliveryInstructionString,
      })
    );
  };
  if (!options || !heading) return '';
  const lang = capitalizeFirstLetter(intl.locale.split('-')[0]);

  return (
    <div className={ClassNames(css.root, { [className]: className })}>
      <div className={css.goGreenTitle}>
        <div className={css.headerText}>
          <img src={actgreen} alt="" />
        </div>
        <div>
          <Typography variant="body1" component="h3" className={css.title}>
            {heading[lang]}
          </Typography>
          <div className={css.goGreenOptions}>
            <Typography variant="body2" className={css.description}>
              {description[lang]}
            </Typography>
            <div className={css.options}>
              {options.map((option, i) => {
                if (!option?.ENABLE || !option?.VISIBLE) return null;

                const value = option[`type`]
                  .toLowerCase()
                  .replace(/ /g, '-')
                  .replace(/[^\w-]+/g, '');

                return (
                  <Grid
                    className={ClassNames(css.checkboxContainer, {
                      [css.deActive]: option.VISIBLE === 2,
                    })}
                  >
                    <FormControlLabel
                      key={value + i}
                      onClick={handleGoGreen(option?.type)}
                      control={
                        <Checkbox
                          key={value + 'checkbox'}
                          checkedIcon={<TiTick className={css.icon} />}
                          checked={checkedOptions[option?.type] == 1}
                        />
                      }
                      label={option[`name_${lang.toLowerCase()}`]?.toLowerCase()}
                    />
                  </Grid>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
